import React from "react";
import { OnlineFormRequestEditFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const OnlineFormRequestEditForm = ({
  answer_list,
  pdpa_details,
  type,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    new_answer: yup.string().required("required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { t, i18n } = useTranslation(["common", "register"]);

  return (
    <OnlineFormRequestEditFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="input_wrap">
            {type === "1" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Radio
                    {...field}
                    options={
                      answer_list
                        ? answer_list.map((e) => ({
                            label: e.ans,
                            value: e.ans,
                          }))
                        : []
                    }
                    // errors={
                    //   errors?.questions &&
                    //   errors?.questions[index]?.answer?.message
                    // }
                  />
                )}
                name="new_answer"
                defaultValue=""
              />
            )}
            {type === "2" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextArea
                    {...field}
                    theme_activity_form
                    // errors={
                    //   errors?.questions &&
                    //   errors?.questions[index]?.answer?.message
                    // }
                  />
                )}
                name="new_answer"
                defaultValue=""
              />
            )}
            {type === "3" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.UploadApi
                    {...field}
                    maxMBFileSizeWarning={8}
                    placeholder={t("Add File or Photo", { ns: "common" })}
                    // errors={
                    //   errors?.questions &&
                    //   errors?.questions[index]?.answer?.message
                    // }
                  />
                )}
                name="new_answer"
                defaultValue=""
              />
            )}
            {type === "4" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Radio
                    {...field}
                    options={[
                      {
                        label:
                          i18n.language === "en"
                            ? pdpa_details?.privacy_accept_label_en || "ยินยอม"
                            : pdpa_details?.privacy_accept_label_th || "ยินยอม",
                        value: "1",
                      },
                      {
                        label:
                          i18n.language === "en"
                            ? pdpa_details?.privacy_decline_label_en ||
                              "ไม่ยินยอม"
                            : pdpa_details?.privacy_decline_label_th ||
                              "ไม่ยินยอม",
                        value: "2",
                      },
                    ]}
                    // errors={
                    //   errors?.questions &&
                    //   errors?.questions[index]?.answer?.message
                    // }
                  />
                )}
                name="new_answer"
                defaultValue=""
              />
            )}
          </div>
          <div className="btn_wrap">
            <Buttons.BgStandard
              type="submit"
              label={t("Confirm", { ns: "common" })}
            />
          </div>
        </div>
      </form>
    </OnlineFormRequestEditFormStyled>
  );
};

OnlineFormRequestEditForm.propTypes = {};

export default OnlineFormRequestEditForm;
